import { render, staticRenderFns } from "./LandingPages.vue?vue&type=template&id=8f6cdaa8&scoped=true&"
import script from "./LandingPages.vue?vue&type=script&lang=ts&"
export * from "./LandingPages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6cdaa8",
  null
  
)

export default component.exports